import * as React from 'react';
import invariant from 'invariant';

import BoxBody from 'components/BoxBody';
import Button, { ButtonColor } from 'components/ButtonDeprecated';
import Buttons from 'components/Buttons';
// @ts-ignore
import Copy from 'components/Copy';
import Dialog from 'components/Dialog';
// @ts-ignore
import Field from 'components/Field';
// @ts-ignore
import Label from 'components/Label';
import Row from 'components/Row';
import Textarea from 'components/Textarea';
// @ts-ignore
import ToastActions from 'actions/ToastActions';
import { ChangeHandler } from 'types/typescript/eventHandlers';

type Props = {
  confirmButtonLabel: string;
  confirmAction: (message: string) => Promise<any>;
  confirmErrorMessage: string;
  confirmSuccessMessage: string;
  copy: string | React.ReactElement;
  eventScreenName: string;
  onConfirmSuccess: () => void;
  onRequestHide: () => void;
  title: string;
};

type State = {
  isSubmitting: boolean;
  message: string;
};

export default class ConfirmWithMessageDialog extends React.Component<Props, State> {
  state = {
    isSubmitting: false,
    message: '',
  };

  closeModal = () => {
    const { onRequestHide } = this.props;
    invariant(onRequestHide, 'modal must have onRequestHide');
    onRequestHide();
  };

  handleMessageChange: ChangeHandler<HTMLTextAreaElement> = event => {
    this.setState({ message: event.target.value });
  };

  handleConfirmation = () => {
    const {
      confirmSuccessMessage,
      confirmErrorMessage,
      confirmAction,
      onConfirmSuccess,
    } = this.props;
    const { message } = this.state;

    this.setState({ isSubmitting: true });

    return confirmAction(message)
      .then(() => {
        ToastActions.showSuccessToast(confirmSuccessMessage);
        onConfirmSuccess();
      })
      .catch(() => {
        ToastActions.showErrorToast(confirmErrorMessage);
      })
      .finally(() => {
        this.closeModal();
      });
  };

  renderBody = () => {
    const { copy, confirmButtonLabel } = this.props;
    const { message, isSubmitting } = this.state;

    return (
      <BoxBody divided>
        <Row>
          <Copy color="graphite">{copy}</Copy>
        </Row>
        <Field>
          <Label>Optional message</Label>
          <Textarea
            value={message}
            placeholder="Type your message here"
            onChange={this.handleMessageChange}
          />
        </Field>
        <Buttons axis="y">
          <Button
            data-test="confirm-button"
            color={ButtonColor.mascot}
            level="primary"
            full
            disabled={isSubmitting}
            onClick={this.handleConfirmation}>
            {confirmButtonLabel}
          </Button>
          <Button color={ButtonColor.mascot} level="text" onClick={this.closeModal}>
            Cancel
          </Button>
        </Buttons>
      </BoxBody>
    );
  };

  render() {
    const { eventScreenName, onRequestHide, title } = this.props;

    return (
      <Dialog
        eventScreenName={eventScreenName}
        size="small"
        onRequestHide={onRequestHide}
        title={title}>
        {this.renderBody()}
      </Dialog>
    );
  }
}
